// Load all the controllers within this directory and all subdirectories.
// Controller files must be named *_controller.js.
//
// Migrated from Webpack's `require.context` to Vite's `import.meta.glob`.
// Identifiers are derived with Stimulus' own `identifierForContextKey`, the
// same function `definitionsFromContext` used under Webpack, so a controller
// at `foo/bar_baz_controller.js` is registered as `foo--bar-baz` and matches
// the dasherized `data-controller` attributes in the views.
import { Application } from 'stimulus';
import { identifierForContextKey } from 'stimulus/webpack-helpers'; // NOPMD

const application = Application.start();

const controllerModules = import.meta.glob('./**/*_controller.js', {
	eager: true,
});

Object.entries(controllerModules).forEach(([path, module]) => {
	application.register(identifierForContextKey(path), module.default);
});
